import React from "react";

export const ShellWalletIcon = () => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3670_32518)">
        <path
          d="M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z"
          fill="#00BDFF"
          fillOpacity="0.1"
        />
        <path
          d="M21.8622 37.2533C19.6962 37.2533 17.7403 36.4853 16.2103 35.0333C14.2363 33.1613 13.1562 30.3593 13.1562 27.1253C13.1562 23.3513 15.1542 20.0993 16.6122 17.7173L16.8342 17.3513C16.9902 17.0993 17.2782 16.9613 17.5722 16.9913C17.8662 17.0153 18.1182 17.2133 18.2203 17.4893C19.1803 20.3093 20.6562 22.4873 21.9522 24.4073C23.4162 26.5673 24.6762 28.4393 24.6762 30.5033C24.6762 32.1773 23.4102 33.3953 21.6582 33.3953C20.6442 33.3953 19.7082 32.9813 18.9522 32.1953C17.4822 30.6713 16.8642 27.9293 17.0322 26.1293C17.0682 25.7273 17.4403 25.4333 17.8602 25.4693C18.2803 25.5053 18.5922 25.8593 18.5562 26.2553C18.4182 27.7373 18.9643 30.0533 20.0802 31.2173C20.5542 31.7093 21.0702 31.9493 21.6642 31.9493C22.5822 31.9493 23.1522 31.3973 23.1522 30.5093C23.1522 28.8713 22.0542 27.2513 20.6682 25.1993C19.5522 23.5493 18.3102 21.7133 17.3382 19.4273C16.0782 21.5393 14.6802 24.2153 14.6802 27.1253C14.6802 29.9633 15.6042 32.4053 17.2842 34.0013C18.5202 35.1773 20.1042 35.8013 21.8622 35.8013H21.8862C24.8622 35.7893 27.1062 33.6113 27.1062 30.7193C27.1062 27.7793 25.4022 25.2533 23.7582 22.8173C22.1322 20.4053 20.4462 17.9093 20.4402 15.0233C20.4402 12.5573 21.6882 10.3133 23.9502 8.70534C24.2682 8.47734 24.7062 8.51933 24.9762 8.80133C26.7582 10.7093 35.6742 20.5793 35.6982 27.5753C35.7102 31.1753 34.2762 34.3073 31.7562 36.1553C31.4982 36.3413 31.1622 36.3593 30.8862 36.1973C30.6162 36.0473 30.4782 35.7413 30.5322 35.4413C30.9582 33.3533 31.0362 32.7173 31.0362 31.1813C31.0362 26.7173 28.4682 22.6793 26.2002 19.1213C25.5462 18.0953 24.9342 17.1353 24.4002 16.1873C24.2083 15.8453 24.3282 15.4133 24.6702 15.2213C24.6823 15.2153 24.6942 15.2093 24.7062 15.2033C25.0722 15.0113 25.5282 15.1373 25.7382 15.4973C26.2602 16.4093 26.8662 17.3633 27.5022 18.3713C29.8722 22.0973 32.5542 26.3153 32.5542 31.1873C32.5542 32.0453 32.5302 32.6513 32.4462 33.3473C33.5562 31.8053 34.1622 29.8073 34.1562 27.5813C34.1382 22.7333 28.9422 15.3653 24.2982 10.2953C23.2422 11.1893 21.9462 12.7493 21.9462 15.0233C21.9522 17.4833 23.4462 19.6973 25.0242 22.0373C26.7882 24.6533 28.6122 27.3533 28.6122 30.7253C28.6122 34.3793 25.6482 37.2473 21.8682 37.2593C21.8802 37.2533 21.8682 37.2533 21.8622 37.2533Z"
          fill="url(#paint0_linear_3670_32518)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_3670_32518"
          x1="13.3535"
          y1="8.5586"
          x2="35.8716"
          y2="8.6952"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#37DCF2" />
          <stop offset="1" stopColor="#07C0FB" />
        </linearGradient>
        <clipPath id="clip0_3670_32518">
          <rect width="48" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
